// Create quotation tab wraps the quotation builder in its own file for focused debugging.
export default function CreateQuotationTab({
  customers,
  transports,
  designs,
  handleSaveQuotation,
  quotationSaving,
  editQuotation,
  setEditQuotation,
  QuotationBuilder,
  quotationSettings,
  quotations,
  showToast,
  onBack,
  confirm,
}) {
  return (
    <QuotationBuilder
      customers={customers}
      transports={transports}
      designs={designs}
      onSave={handleSaveQuotation}
      saving={quotationSaving}
      initialQuotation={editQuotation}
      onCancelEdit={() => setEditQuotation(null)}
      quotationSettings={quotationSettings}
      quotations={quotations}
      showToast={showToast}
      onBack={onBack}
      confirm={confirm}
    />
  );
}
